import React, { useState, useEffect } from "react";
import { Row, Col, InputPicker, Icon, Button, ControlLabel, Input, InputGroup, Form,
    FormControl, FormGroup, ButtonToolbar, Alert
} from 'rsuite';
import { TitleSection } from "../../components/titleSection";
import { statmentService } from "../../services/statment.service";
import { useTranslation } from "react-i18next";

export const StatmentQuery = (props) => {

    const { t, i18n } = useTranslation();
    const [listPeriod, setListPeriod] = useState([]);
    const [valueSelected, setValueSelected] = useState("");
    const [itemSaldo, setItemSaldo] = useState({ saldo: 0, cargos: 0, abonos: 0 });
    const [haveData, setHaveData] = useState(false);

    useEffect(() => {
        statmentService.GetPeriods(i18n.language).then((result) => {
            if (result.length > 0) { setHaveData(true); }
            setListPeriod(result);
        });
    }, [props.id, i18n.language]);

    const inputChange = (value) => {
        if (value) {
            let item = listPeriod.filter(x => { return value === x.value });
            setItemSaldo(item[0]);
            setValueSelected(value);
        }
        else {
            setItemSaldo({ saldo: 0, cargos: 0, abonos: 0 });
            setValueSelected("");
        }
    }

    const onClickDownload = () => {
        if (valueSelected == "" || valueSelected == null) {
            Alert.error(t('statment.periodmissing'));
            return false;
        } else {
            statmentService.GetStatmentPdf(valueSelected)
                .then((response) => {
                    const fileurl = window.URL.createObjectURL(response);
                    let alink = document.createElement("a");
                    alink.href = fileurl;
                    alink.download = `statment_Id${sessionStorage["rp_company"]}_periodo${valueSelected}`;
                    alink.click();
                });
        }
    }

    return (

        <section className="wrapper_transactions">
            <TitleSection title={t('statment.title')} />
            <Form>
                <Row>
                    <div className="mt-3 mb-5">
                        <FormGroup>
                            <ControlLabel>{t('statment.period')}</ControlLabel>
                            <FormControl
                                accepter={InputPicker}
                                placeholder={t('statment.selectperiod')}
                                data={listPeriod}
                                onChange={inputChange}
                            />
                        </FormGroup>
                    </div>
                </Row>
                <Row>
                    <Col xs={8}>
                        <h5>Detalles</h5>
                    </Col>
                    <Col xs={8}></Col>
                </Row>
                <div><br></br></div>
                <Row>
                    <Col xs={8}>
                        <FormGroup>
                            <ControlLabel>{t('statment.credits')}</ControlLabel>
                            <InputGroup>
                                <InputGroup.Addon>$</InputGroup.Addon>
                                <Input value={itemSaldo.abonos} disabled />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col xs={8}>
                        <FormGroup>
                            <ControlLabel>{t('statment.charges')}</ControlLabel>
                            <InputGroup>
                                <InputGroup.Addon>$</InputGroup.Addon>
                                <Input value={itemSaldo.cargos} disabled />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col xs={8}>
                        <FormGroup>
                            <ControlLabel>{t('statment.balance')}</ControlLabel>
                            <InputGroup>
                                <InputGroup.Addon>$</InputGroup.Addon>
                                <Input value={itemSaldo.saldo} disabled />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                </Row>
                <div><br></br></div>
                <Row>
                    <div className="text-right">
                        <ButtonToolbar>
                            <Button color="green"
                                onClick={haveData ? onClickDownload : undefined}
                            >{t('statment.download')} <Icon icon="chevron-circle-down" />
                            </Button>
                        </ButtonToolbar>
                    </div>
                </Row>
            </Form>
        </section >
    );
};